import { useState } from "react";

import { cn } from "@/utils/helpers";

const BROKEN_IMAGE_SRC =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Cg transform='translate(48 48)' fill='none' stroke='%239ca3af' stroke-opacity='0.55' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='2' y1='2' x2='22' y2='22'/%3E%3Cpath d='M10.41 10.41a2 2 0 1 1-2.83-2.83'/%3E%3Cline x1='13.5' y1='13.5' x2='6' y2='21'/%3E%3Cline x1='18' y1='12' x2='21' y2='15'/%3E%3Cpath d='M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59'/%3E%3Cpath d='M21 15V5a2 2 0 0 0-2-2H9'/%3E%3C/g%3E%3C/svg%3E";

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export function Image({ className, src, onLoad, onError, ...rest }: ImageProps) {
  const [loadedSrc, setLoadedSrc] = useState<string>();
  const [failedSrc, setFailedSrc] = useState<string>();

  const failed = src !== undefined && failedSrc === src;
  const loaded = src === undefined || failed || loadedSrc === src;

  return (
    <img
      {...rest}
      src={failed ? BROKEN_IMAGE_SRC : src}
      ref={(node) => {
        if (!failed && node?.complete && node.naturalWidth > 0) setLoadedSrc(src);
      }}
      onLoad={(event) => {
        if (failed) return;
        setLoadedSrc(src);
        onLoad?.(event);
      }}
      onError={(event) => {
        if (failed) return;
        onError?.(event);
        setFailedSrc(src);
      }}
      className={cn(
        !loaded && "bg-co-surface-solid motion-safe:animate-pulse",
        failed && "bg-co-surface-solid",
        className,
      )}
    />
  );
}
